import React, { useEffect, useState } from 'react';
import { Column, Table, PageBar } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { dmpTypeMap } from './util';
import { Tags } from '../../../consts/Tags';

const LeadsAPIColumns = [
  {
    name: "leadsId",
    fixedable: true,
    title: "线索ID",
  },
  {
    name: "tel",
    fixedable: true,
    title: "电话",
  },
  {
    name: "campaignName",
    adjustWidth: true,
    fixedable: true,
    title: "推广计划",
  },
  {
    name: "adName",
    adjustWidth: true,
    title: "广告",
  },
  {
    name: "advertiserId",
    adjustWidth: true,
    fixedable: true,
    title: "推广账号",
  },
  {
    name: "actionSubType",
    adjustWidth: true,
    title: "线索类型",
  },
  {
    name: "leadsSource",
    adjustWidth: true,
    title: "线索来源",
  },
  {
    name: "leadsCreatedTime",
    adjustWidth: true,
    title: "线索提交时间",
  },
  {
    name: "reportActionTime",
    adjustWidth: true,
    title: "线索上报时间",
  },
  {
    name: "reportActionType",
    adjustWidth: true,
    title: "线索上报事件",
  }
];
const ActionAPIColumns = [
  {
    name: "uniqueId",
    fixedable: true,
    title: "线索标志ID",
  },
  {
    name: "campaign",
    adjustWidth: true,
    fixedable: true,
    title: "推广计划",
  },
  {
    name: "advertisement",
    adjustWidth: true,
    title: "广告",
  },
  {
    name: "linkPath",
    adjustWidth: true,
    title: "投放链路",
  },
  {
    name: "crudActionType",
    adjustWidth: true,
    title: "浅层行为",
  },
  {
    name: "crudActionTime",
    adjustWidth: true,
    title: "浅层上报时间",
  },
  {
    name: "validActionType1",
    adjustWidth: true,
    title: "有效行为1",
  },
  {
    name: "validAction1ReportTime",
    adjustWidth: true,
    title: "有效行为1上报时间",
  },
  {
    name: "validActionType2",
    adjustWidth: true,
    title: "有效行为2",
  },
  {
    name: "validAction2ReportTime",
    adjustWidth: true,
    title: "有效行为2上报时间",
  },
  {
    name: "isStore",
    adjustWidth: true,
    title: "是否到店",
  },
  {
    name: "isPurchase",
    adjustWidth: true,
    title: "是否成单",
  },
  {
    name: "isValid",
    adjustWidth: true,
    title: "是否无效",
  },
  {
    name: "firstDeepActionTime",
    adjustWidth: true,
    title: "首次深层上报时间",
  }
];
export const UploadDetailTable = (props) => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(props.dataSource === 'leads-web' ? LeadsAPIColumns : ActionAPIColumns);
  const [pageIndex, setPageValue] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalDataSize, setDataSize] = useState(20);
  const handlePageChange = (event, value) => {
    setPageValue(value);
  };

  const handlePageSizeChange = (value, pageSize) => {
    // 切换每页数量
    setPageValue(value);
    setPageSize(pageSize);
  };
  useEffect(() => {
    if(props.dataSource === 'leads-web') {
      setColumns(LeadsAPIColumns);
    } else {
      setColumns(ActionAPIColumns);
    }
  }, [props.dataSource])
  useEffect(() => {
    if(props.dataSource === 'leads-web') {
      const param = {
        startDate: props.startDate,
        endDate: props.endDate,
        queryAccountId: props.queryAccountId,
        pageSize,
        pageIndex,
        ... (props.actionSubTypes.length ? { actionSubTypes: props.actionSubTypes } : {}),
        ... (props.leadsSources.length ? { leadsSources: props.leadsSources } : {}),
      };
      RPCFactory.DMPUpload.getDmpUploadDetail(param)
        .done((data) => {
          setData(data.entities);
          setDataSize(data?.page_info?.total_number);
        })
        .fail((ret, msg) => {
          alert(msg);
        });
    } else {      
      const param = {
        startDate: props.startDate,
        endDate: props.endDate,
        accountId: props.queryAccountId,
        pageSize,
        pageIndex,
        ... (props.actionPaths.length ? { linkPaths: props.actionPaths } : {}),
      };
      RPCFactory.DMPUpload.getActionAPIDetail(param)
        .done((data) => {
          setData(data.entities);
          setDataSize(data?.page_info?.total_number);
        })
        .fail((ret, msg) => {
          alert(msg);
        });
    }
  }, [
    props.queryAccountId,
    props.actionPaths,
    props.dataSource,
    props.actionSubTypes,
    props.leadsSources,
    props.startDate,
    props.endDate,
    pageIndex,
    pageSize,
  ]);
  const columnRender = (type, name, value, data) => {
    let result = '';
    if (type === 'data') {
      switch (name) {
        case 'reportActionType':
          result = (
            <span>{value ? `${dmpTypeMap[value].name}线索` : ''}</span>
          );
          break;
        case 'actionSubType':
          result = (
            <span>{value >= 0 ? Tags.actionSubTypeTag[value] : ''}</span>
          );
          break;
        case 'leadsSource':
          result = (
            <span>{value ? Tags.leadsSourceTag[value] : ''}</span>
          );
          break;
        case 'isStore':
          result = (
            <span>{value ? '是' : '否'}</span>
          );
          break;
        case 'isPurchase':
          result = (
            <span>{value ? '是' : '否'}</span>
          );
          break;
        case 'isValid':
          result = (
            <span>{value ? '是' : '否'}</span>
          );
          break;

        default:
          result = (
              <div>{value}</div>
          );
          break;
      }
    } else {
      result = (
          <div>{value}</div>
      );
    }
    return result;
  };

  return (
    <>
      <Table
        data={data}
        useOldClass={false}
        className='detail-table'
        cellPadding={'12px'}
        firstCellPadding={'12px'}
        lastCellPadding={'12px'}
        fixedRows={0}
        trHoverBg={''}
        borderColor={''}
        cellBorderColor={''}
        theadBg={''}
        cellHeight={''}
        theadCellHeight={''}
        striped={false}
        hover={false}
        bordered={false}
        adjustWidthClassName='spaui-table-td-adjust-width'
        adjustWidthClassNameTrigger="hover"
      >
        {columns.map((column, index) => (
          <Column
            key={index}
            render={columnRender}
            className={`${column.className}${column.tips ? ' with-popover' : ''}`}
            {...column}
          >
            {column.title}
          </Column>
        ))}
      </Table>
      <PageBar
          value={pageIndex}
          pageSize={pageSize}
          pageSizeList={[10, 20, 50]}
          totalSize={totalDataSize}
          onChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
      />
    </>
  );
};
